// extracted by mini-css-extract-plugin
export var button = "_gd-4";
export var hasDarkBackground = "_gd-7";
export var hasLightBackground = "_gd-6";
export var iconWrapper = "_gd-0";
export var large = "_gd-2";
export var medium = "_gd-1";
export var small = "_gd-5";
export var xsmall = "_gd-3";